export function PhoneIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2.40039 3.59844C2.40039 2.9357 2.93765 2.39844 3.60039 2.39844H6.18384C6.77045 2.39844 7.27107 2.82253 7.36751 3.40116L8.25469 8.72421C8.34129 9.24385 8.07886 9.7592 7.60767 9.9948L5.7499 10.9237C7.08946 14.2524 9.74641 16.9094 13.0751 18.2489L14.004 16.3912C14.2396 15.92 14.755 15.6575 15.2746 15.7441L20.5977 16.6313C21.1763 16.7278 21.6004 17.2284 21.6004 17.815V20.3984C21.6004 21.0612 21.0631 21.5984 20.4004 21.5984H18.0004C9.38475 21.5984 2.40039 14.6141 2.40039 5.99844V3.59844Z'
        fill='currentColor'
      />
    </svg>
  )
}
